import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  const getChangeIcon = (change: string) => {
    if (change === 'up') return <i className="ri-arrow-up-fill text-accent-500 text-xs"></i>;
    if (change === 'down') return <i className="ri-arrow-down-fill text-foreground-400 text-xs"></i>;
    if (change === 'new') return <span className="text-xs font-bold text-accent-500">NEW</span>;
    return <span className="text-xs text-foreground-400">—</span>;
  };

  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            热播排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            实时热度排行，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 p-4 md:p-5 transition-colors hover:bg-background-100 cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className="flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center font-label text-sm font-extrabold">
                {item.rank <= 3 ? (
                  <span className={`text-lg ${
                    item.rank === 1 ? 'text-accent-500' :
                    item.rank === 2 ? 'text-primary-500' :
                    'text-secondary-500'
                  }`}>
                    {item.rank === 1 ? <i className="ri-medal-fill"></i> :
                     item.rank === 2 ? <i className="ri-medal-fill"></i> :
                     <i className="ri-medal-fill"></i>}
                  </span>
                ) : (
                  <span className="text-foreground-500">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.type}</div>
              </div>

              <div className="flex-shrink-0 text-xs font-medium text-foreground-700 hidden sm:block">
                {item.hot}
              </div>

              <div className="flex-shrink-0 w-8 flex items-center justify-center">
                {getChangeIcon(item.change)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}